import React from "react"
import {findDOMNode} from "react-dom"

import formatDate from "../../../gd/format/date"
import ControlButtonStandard from "../../buttons/control-button/control-button-standard"
import {momentRange} from "../../../gd/convert/moment-range"
import Popover from "../../gd-popover/popover-v2"
import PopoverPosition from "../../gd-popover/popover-position"
import {PopoverAttachmentType} from "../../gd-popover/@const"
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"

// @ts-ignore
import DateRangeCalendar from './components/daterange-calendar'

type Props = {
    className?              : string

    isOpen                  : boolean
    placeholder             : string
    value?                  : any

    form?                   : any
    startName?              : string
    endName?                : string

    minDate?                : any
    maxDate?                : any

    presets                 : any

    dateFormat              : string

    size                    : string
    type                    : 'default' | 'top' | 'top-extended' | 'inline' | 'form' | 'form-default' |
                              'form-default-icon' | 'text-14' | 'text-normal' | 'text-13' | 'text-12' |
                              'text-11' | 'inline-icon' | 'control-button' | 'func'

    iconSize?               : number // fs-X or default 14px if unset (currently for 'control-button' only)

    iconOnly                : boolean
    noIcon?                 : boolean
    disabled?               : boolean

    btnNoValue?             : boolean
    btnNoValueLabel?        : string

    hint?                   : string

    // underline
    underlined              : 'on-hover' | 'always' | 'never'  // if set will show border bottom for the value

    popoverAttachment       : string
    popoverTargetAttachment : string
    popoverTargetOffset     : string
    attachmentType          : PopoverAttachmentType
    tetherConstraints?      : any

    renderFunc?             : func
    onTogglePopover?        : func
    onChange?               : func
    onUserSelect?           : func
}

type State = {
    showPopover : boolean
    value       : any
    isOpen      : boolean
}

export default class DateRangePicker extends React.Component<Props, State> {

    static defaultProps = {
        size                    : "small",
        type                    : "default",
        iconOnly                : false,
        isOpen                  : false,
        placeholder             : "Please select",

        underlined              : 'on-hover',

        popoverTargetOffset     : "0 0",
        popoverAttachment       : 'top left',
        popoverTargetAttachment : 'bottom left',
        attachmentType          : "horizontal",
        presets                 : null,

        dateFormat              : 'MMM DD'
    };

    constructor(props: Props) {

        super(props)

        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.startName,this)
            this.props.form.registerFormComponent(this.props.endName,this)
        }

        this.state = {
            showPopover : false,
            value       : this._initValue(props),
            isOpen      : false
        }
    }

    componentDidMount(){
        if(this.props.isOpen) {
            this.setState({
                isOpen: true
            })
        }
    }

    UNSAFE_componentWillUpdate(nextProps: Props, nextState: State){
        if (!_.isEqual(nextState.value,this.state.value)) {
            this.handleChangeItem(nextState.value);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        this.setState({
            value: this._initValue(nextProps)
        });
    }

    shouldComponentUpdate(nextProps: Props, nextState: State) {
        return !( _.isEqual(nextProps, this.props) && _.isEqual(nextState, this.state) )
    }

    showPopover = (e?: React.MouseEvent, callback?: func) => {
        e?.stopPropagation()

        this.setState({
            showPopover: true
        }, ()=>{
            this.props.onTogglePopover?.(true)
            callback?.()
        })
    }

    hidePopover = (e?: React.MouseEvent, callback?: func) => {
        e?.stopPropagation()

        this.setState({
            showPopover: false
        }, ()=>{
            this.props.onTogglePopover?.(false)
            callback?.()
        })
    }

    togglePopover = (e?: React.MouseEvent, callback?: func) => {
        e?.stopPropagation()

        const newValue = !this.state.showPopover
        this.setState({
            showPopover: newValue
        }, ()=>{
            this.props.onTogglePopover?.(newValue)
            callback?.()
        })
    }

    _initValue(props: Props) {
        return props.form && props.form.getValue(props.startName) ?
            momentRange(
                moment(props.form.getValue(props.startName)),
                props.form.getValue(props.endName) ?
                    moment(props.form.getValue(props.endName))
                    :
                    moment(props.form.getValue(props.startName))
            )
            :
            props.value
    }

    getValue = () => {
        this.state.value
    }

    onDateRangeSelected = (range: any) => {
        // range is a moment range object
        if (this.props.form) {
            this.props.form.onFormComponentValueChange(this.props.startName,range ? range.start : null)
            this.props.form.onFormComponentValueChange(this.props.endName,range ? range.end : null)
        }

        this.setState({
            value: range
        }, ()=> {
            this.hidePopover()
            this.handleSelectItem(range)
        });
    }

    handleChangeItem = (range: any) => {
        this.props.onChange?.(range)
    }

    handleSelectItem = (range: any) => {
        this.props.onUserSelect?.(range)
    }

    renderPopover() {
        if (this.state.showPopover) {
            const presets: any[] = _.compact([].concat(this.props.presets))
            if (this.props.btnNoValue) {
                presets.push(
                    {label: this.props.btnNoValueLabel, onClick: ()=>{this.onDateRangeSelected(null)}}
                )
            }

            const popoverPosition = new PopoverPosition({
                attachment      : this.props.popoverAttachment,
                targetAttachment: this.props.popoverTargetAttachment,
                targetOffset    : this.props.popoverTargetOffset,
                attachmentType  : this.props.attachmentType,
            })

            return (
                <Popover
                    popoverClass        = "daterange-picker-popover"
                    className           = "daterange-picker-popover-container"
                    position            = {popoverPosition}
                    constraints         = {this.props.tetherConstraints}
                    getTargetFunc       = {()=>findDOMNode(this)}
                    onClickOutside      = {()=>{this.hidePopover()}}
                >
                    <DateRangeCalendar
                        className       = "daterange-picker-calendar"
                        presets         = {presets}
                        selectedRange   = {this.state.value}
                        minDate         = {this.props.minDate}
                        maxDate         = {this.props.maxDate}
                        onSelect        = {this.onDateRangeSelected}
                    />
                </Popover>
            )
        }

        return null
    }

    renderValue() {

        let valueItem = this.props.placeholder
        if (this.state.value) {
            // valueItem = "{0} - {1}".f(this.state.value.start.format(this.props.dateFormat), this.state.value.end.format(this.props.dateFormat))
            valueItem = "{0} - {1}".f(
                formatDate(this.state.value.start, this.props.dateFormat),
                formatDate(this.state.value.end, this.props.dateFormat)
            )
        }

        const curValueClasses = Classes('gd-daterange-control', {
            'no-value': !this.state.value
        })

        switch (this.props.type) {
            case 'inline': {
                const classes = Classes(curValueClasses, "ui5-circle-selector", {
                    "p-h-10": !!this.state.value
                })

                const iconClasses = Classes("icon i5-calendar", {
                    "m-r-5": !!this.state.value
                })

                return (
                    <div className  = {classes}
                         onClick    = {!this.props.disabled ? this.togglePopover : undefined}
                    >
                        <div className={iconClasses}/>
                        <div className="ui5-txt-no-accent-small">
                            {!!this.state.value && valueItem}
                        </div>
                    </div>
                )
            }

            case 'form-default-icon':
                return (
                    <div className  = "gd-daterange-control flex-row-between-center"
                         onClick    = {!this.props.disabled ? this.togglePopover : undefined}
                    >
                        <div className="flex-row-left-center">
                            <div className="icon i5-calendar p-l-10 ui5-ico-14"/>
                            <div className="gd-daterange-value">
                                {!this.props.iconOnly && valueItem}
                            </div>
                        </div>
                        {/*<div className="i5-big-angle-down fs-9 ui5-color-not-important p-r-15"/>*/}
                    </div>
                )

            case 'inline-icon':
                return (
                    <div className  = {curValueClasses}
                         onClick    = {!this.props.disabled ? this.togglePopover : undefined}
                    >
                        <div className="picker-icon  i5-calendar"/>
                        {!!this.state.value && valueItem}
                    </div>
                )

            case 'func':
                return this.props.renderFunc?.(this.props, this.state, this.togglePopover)

            case 'control-button':
                const iconClasses = Classes("i5-calendar", {
                    ['fs-'+this.props.iconSize]: !!this.props.iconSize
                })

                return (
                    <ControlButtonStandard
                        iconClass   = {iconClasses}
                        isDisabled  = {this.props.disabled}
                        onClick     = {!this.props.disabled ? this.togglePopover : undefined}
                    />
                )

            default: {
                const classes = Classes(curValueClasses, {
                    'underlined-never'                      : this.props.disabled,
                    ['underlined-'+this.props.underlined]   : !this.props.disabled
                })

                return (
                    <div className  = {classes}
                         onClick    = {!this.props.disabled ? this.togglePopover : undefined}
                    >
                        <div className="gd-daterange-value">
                            {!this.props.iconOnly && valueItem}
                        </div>
                        {!this.props.noIcon &&
                            <div className=" i5-calendar"/>}
                    </div>
                )
            }
        }
    }

    render() {

        const selectClassName = Classes('gd-daterange-picker', this.props.type+"-type", this.props.className, {
            [this.props.size]   : this.props.type !== 'inline',
            'disabled'          : this.props.disabled,
            'icon-only'         : this.props.iconOnly,
            'show-popover'      : this.state.showPopover
        });

        return (
            <div className={selectClassName}>
                {this.renderValue()}
                {this.renderPopover()}

                {!this.state.showPopover &&
                    <HintPopover hint={this.props.hint}/>}
            </div>
        )
    }
}
